export default {
  header: 'Contact support',
  toggleTitle: '1. Turn on error tracking mode',
  toggleDescription:
    'This will help us locate your issues, but may slightly affect your app performance.',
  downloadTitle:
    '2. Download the error log when you have replicated the issue.',
  downloadButton: 'Download',
  downloadDisabledTitle:
    'Turn on error tracking mode before you can download error log.',
  sendTitle: '3. Send the log to support team',
  createSupportTicket: 'Create a support ticket',
  sendDescription:
    ' to get in touch with our support team. Then send the log to the support team for troubleshooting.',
  privacyNotice:
    'By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our ',
  privacyNoticeLink: 'Terms of Service',
  and: ' and ',
  privacyNoticeEnd: 'Privacy Notice.',
  needLeavePage:
    'You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files.',
  downloading: 'Downloading',
} as const;
